import GroupFilter from "./GroupFilter";

/**
 * A group of radio buttons — single-select. Value is a single scalar term id (or "").
 */
export default class RadioFilter extends GroupFilter {
    get multiple() {
        return false;
    }
}
